import './Anchor.scss';

import cn from 'classnames';
import { ComponentPropsWithoutRef } from 'react';

const cssClassName = 'c-Anchor';

export default function Anchor({
  className,
  ...restProps
}: ComponentPropsWithoutRef<'a'>) {
  return <a className={cn(cssClassName, className)} {...restProps} />;
}
